// extracted by mini-css-extract-plugin
export default {"inputStyles":"pure-checkbox_inputStyles__T5jjO","requiredAsterisk":"pure-checkbox_requiredAsterisk__x00uI"};